import { Box } from '@mantine/core';
import { ConfigFieldValue } from '@/types/automationFields.ts';
import StyledTextArea from '@/components/StyledInputFields/StyledTextarea.tsx';
import useFieldConfigError from '@/hooks/useFieldConfigError.ts';
import { IntegrationTextConfigField } from '@/types/integrations.ts';

type props = {
  stepId: string;

  field: IntegrationTextConfigField;
  fieldValue: any;
  fieldValueConfig: ConfigFieldValue;
  onChange: (updated_value: any) => void;
};

const JsonField = ({ stepId, field, fieldValue, fieldValueConfig, onChange }: props) => {
  const error = useFieldConfigError(stepId, fieldValueConfig);

  return (
    <Box pos="relative">
      <StyledTextArea
        label={field.display_name}
        value={fieldValue ?? ''}
        description={field.description ?? undefined}
        placeholder={field.placeholder ?? undefined}
        onChange={(event) => onChange(event.currentTarget.value)}
        required={field.required}
        autosize={true}
        minRows={2}
        maxLength={field.max_length ?? undefined}
        error={error?.message}
        disabled={fieldValueConfig.is_disabled}
      />
    </Box>
  );
};

export default JsonField;
